var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.536 12.342l-.08.31-1.515 5.911h0a.5.5 0 00.765.538l.83-6.759zm0 0l-.248-.202-4.794-3.907h0a.5.5 0 01.316-.887h6.548l.115-.34L10.544.9h0a.5.5 0 01.945-.006h0l2.156 6.118.118.334h6.431a.5.5 0 01.317.888l-4.785 3.907-.247.201.079.31 1.505 5.911a.5.5 0 01-.765.538h0l-5.01-3.41-.28-.19-.282.19-5.02 3.41.83-6.759z",
    stroke: "currentColor"
  })));
}

var MemoSvgStarOutline = /*#__PURE__*/React.memo(SvgStarOutline);
export default MemoSvgStarOutline;